module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.6998/img/storefront-header-blobs.svg"